<template>
  <div
    class="sailor"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.3)"
  >
    <div class="sailor-title">
      <p>海员风采</p>
      <div style="display: flex; margin-right: 8px">
        <el-input
          class="sailor-input"
          placeholder="请输出标题或者内容"
          v-model="mediaName"
        ></el-input>
        <div class="search-sailor" @click="searchSailor">
          <img src="@/assets/search-sailor.png" alt="" />
        </div>
      </div>
    </div>
    <div class="no-messages" v-if="photoList.length == 0">
      <img src="@/assets/none-mess.png" alt="" />
      <p>暂无数据</p>
    </div>
    <div class="crew-photo">
      <div class="photo-train" v-for="(item, index) in photoList" :key="index">
        <img :src="item.url" alt="" />
        <div class="photo-font">
          <span :title="item.mediaName">{{ item.mediaName }}</span>
        </div>
        <div class="photo-dec" :title="item.mediaIntroduction">
          {{ item.mediaIntroduction }}
        </div>
      </div>
    </div>
    <div class="page-aiton" v-if="photoList.length > 0">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
//getAllFile
import { selecteMediaInfo, getAllFile } from "@/apis/index";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      test: "",
      photoList: [],
      viedoList: [],
      viedoTitle: "",
      videoVisible: false,
      videoUrl: "",
      urlStr: "",
      mediaName: "",
      loading: true,
      total: 0,
      pageNo: 1,
      pageSize: 12,
    };
  },
  mounted() {},
  created() {
    this.selecteMediaInfoList();
  },
  methods: {
    async selecteMediaInfoList() {
      let res = await selecteMediaInfo({
        mediaType: "1",
        pageSize: 12,
        pageNo: this.pageNo,
        mediaName: this.mediaName,
        showMedia: "1",
      });
      this.urlStr = "";
      res.data.resultList.forEach((item) => {
        this.urlStr +=
          item.pictureUrl[0] == "/"
            ? "file" + item.pictureUrl + ","
            : "file/" + item.pictureUrl + ",";
      });
      let urlLists = this.lookAllFileSrc(this.urlStr);
      urlLists.then((result) => {
        this.urlList = result;
        // console.log(this.urlList);
        res.data.resultList.forEach((item, index) => {
          this.urlList.forEach((val, valIndex) => {
            if (index == valIndex) {
              item.url = val;
            }
          });
        });
      });
      this.total = res.data.rowCount;
      let that = this;
      setTimeout(() => {
        that.photoList = res.data.resultList;
        this.loading = false;
      }, 500);
    },
    async lookAllFileSrc(src) {
      // console.log(src);
      let url = await getAllFile({
        fileNameList: src,
      });
      return url.data;
    },
    searchSailor() {
      this.loading = true;
      this.pageNo = 1;
      this.selecteMediaInfoList();
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.loading = true;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      // 调用后台接口或重新获取数据
      // this.selectRecordList();
      this.selecteMediaInfoList();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
